import styles from './Footer.module.scss';

const TitleAndDescription = () => {
  return <div className={styles.titleAndDescriptionContainer} />;
};

export default TitleAndDescription;
